import React, { useState, useEffect } from 'react'
import LoadingOverlay from 'react-loading-overlay';

declare global {
  interface Window { AjaxZip3: any; }
}


const Index = (props) => {
  // ロード用
  const [isLoading, setIsLoading]  = useState<Boolean>(true);

  return(
    <LoadingOverlay active={isLoading} spinner text='Loading...' >
    </LoadingOverlay>
  )
}
export default Index;